import React from 'react';
import PropTypes from 'prop-types';

import {Divider, Flex, Text} from '@spothero/ui';

const FacilityInformationDisplay = ({title, address}) => {
    return (
        <>
            <Flex gap={4} paddingBottom={4}>
                <Text fontSize="sm" fontWeight="semibold">
                    {title}
                </Text>
                <Text fontSize="sm">{address}</Text>
            </Flex>
            <Divider marginBottom={4} />
        </>
    );
};

FacilityInformationDisplay.propTypes = {
    title: PropTypes.string,
    address: PropTypes.string,
};

export default FacilityInformationDisplay;
